require('core-js/fn/object/assign');
require('core-js/fn/object/values');
require('core-js/fn/string/includes');
require('core-js/fn/array/includes');
require('classlist-polyfill');
